export const HOME = '/';
export const SEARCH = '/s';
export const CART = '/cart';
export const CHECKOUT = '/checkout';
export const CHECKOUT_SHIPPING = `${CHECKOUT}/shipping`;
export const ORDER_CONFIRMATION = '/thank-you';
export const ACCOUNT = '/account';
export const ORDER_HISTORY = `${ACCOUNT}/orders`;
export const ORDER_DETAILS = ORDER_HISTORY;
export const MSI_ONLINE = '/condiciones-promociones-meses-sin-intereses-en-linea';
